// // CareerHeader.js
// import React from 'react';
// import styled from 'styled-components';
// import careerVideo from '../../../assets/images/career/careerheader.mp4'; // Replace with your video path

// const HeaderContainer = styled.header`
//   position: relative;
//   width: 100%;
//   min-height: 100vh;
//   overflow: hidden;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   color: #fff;
//   text-align: center;
//   font-family: "Poppins", system-ui;



  
//   @media (max-width: 768px) {
//     min-height: 80vh;
//   }

//    @media (max-width: 576px) {
//    min-height: 70vh;
//   }
// `;

// const BackgroundVideo = styled.video`
//   position: absolute;
//   top: 50%;
//   left: 50%;
//   width: 100%;
//   height: 100%;
//   object-fit: cover;
//   transform: translate(-50%, -50%);
//   z-index: -1;
// `;

// const Overlay = styled.div`
//   position: absolute;
//   top: 0;
//   left: 0;
//   right: 0;
//   bottom: 0;
//   background: rgba(0, 0, 0, 0.4); /* Dark overlay */
//   z-index: 1;
// `;

// const HeaderText = styled.h1`
//   font-size: 4em;
//   z-index: 2;
//   font-family: "Poppins", system-ui;
//   font-weight: 700;
//   font-style: normal;
  

//   @media (max-width: 768px) {
//     font-size: 3em;
//   }

//   @media (max-width: 576px) {
//     font-size: 2em;
//   }
// `;

// const CareerHeader = () => {
//   return (
//     <HeaderContainer>
//       <BackgroundVideo autoPlay loop muted>
//         <source src={careerVideo} type="video/mp4" />
//         Your browser does not support the video tag.
//       </BackgroundVideo>
//       <Overlay />
//       <HeaderText>Careers</HeaderText>
//     </HeaderContainer>
//   );
// };

// export default CareerHeader;
import React from 'react';
import styled, { keyframes } from 'styled-components';
import careerVideo from '../../../assets/images/career/careerheader.mp4';

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to   { opacity: 1; transform: translateY(0); }
`;

const float = keyframes`
  0%, 100% { transform: translateY(0); }
  50%      { transform: translateY(-6px); }
`;

const HeaderContainer = styled.header`
  position: relative;
  width: 100%;
  min-height: 100vh;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #f9fafb;
  text-align: center;
  font-family: 'Poppins', system-ui;

  @media (max-width: 768px) {
    min-height: 80vh;
  }

  @media (max-width: 576px) {
    min-height: 70vh;
  }
`;

const BackgroundVideo = styled.video`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transform: translate(-50%, -50%);
  z-index: -2;
`;

const Overlay = styled.div`
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at top, rgba(8, 47, 73, 0.8), rgba(15, 23, 42, 0.95));
  mix-blend-mode: multiply;
  z-index: -1;
`;

const HeaderContent = styled.div`
  padding: 0 18px;
  animation: ${fadeIn} 0.85s ease-out;
`;

const HeaderText = styled.h1`
  font-size: 3.5rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  margin-bottom: 12px;

  @media (max-width: 768px) {
    font-size: 2.7rem;
  }

  @media (max-width: 576px) {
    font-size: 2rem;
  }
`;

const SubHeader = styled.p`
  font-size: 1rem;
  max-width: 540px;
  margin: 0 auto;
  color: #e5e7eb;
  line-height: 1.7;
`;

const ScrollHint = styled.div`
  position: absolute;
  bottom: 28px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 0.85rem;
  color: #e5e7eb;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  animation: ${float} 1.8s ease-in-out infinite;

  i {
    font-size: 1rem;
  }
`;

const CareerHeader = () => {
  return (
    <HeaderContainer>
      <BackgroundVideo autoPlay loop muted playsInline>
        <source src={careerVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </BackgroundVideo>
      <Overlay />
      <HeaderContent>
        <HeaderText>Careers</HeaderText>
        <SubHeader>
          Build your next chapter with NexTech – where engineering, innovation, and ownership meet
          real-world impact.
        </SubHeader>
      </HeaderContent>
      <ScrollHint>
        <span>Scroll to explore roles</span>
        <i className="fa-solid fa-chevron-down" />
      </ScrollHint>
    </HeaderContainer>
  );
};

export default CareerHeader;
